import type { DSNCBestProductProps } from 'shared-definitions/types'
import type { ApiBestProductProps } from 'data-source/types.wp'
import { pLinkExternalMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { clearbuyLinkMapper } from 'data-source/mappers/clearbuyLink'
import { ncProductMSRPMapper } from 'data-source/mappers/ncProductMSRPMapper'

export function bestProductPropsMapper(
  input: ApiBestProductProps,
  opts: PLinkMapperOpts
): DSNCBestProductProps {
  return {
    title: input.title,
    pLinkEdit: input.edit_url ? pLinkExternalMapper(input.edit_url) : null,
    score: input.rating !== 0 ? input.rating : null,
    reviewLink: input.review_url
      ? {
          label: 'See review',
          pLink: clearbuyLinkMapper(input.review_url, opts),
        }
      : null,
    productLink: input.shop_url ? clearbuyLinkMapper(input.shop_url, opts) : null,
    msrp: ncProductMSRPMapper(input),
  }
}
